export default __webpack_public_path__ + "static/media/562.2700cb6b.png";